import {
  transition,
  container,
} from "assets/jss/material-dashboard-react.js";

const appStyle = (theme) => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh",
  },
  mainPanel: {
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    paddingTop: "0px",
    position: "relative",
    ...transition,
    overflowScrolling: "touch",
    width: "100%",
    height: "fit-content",
    minHeight: "calc(100vh - 50px)",
    flex: "1 0 0px"
  },
  content: {
    marginTop: "70px",
    padding: "10px 10px",
    minHeight: "calc(100vh - 123px)",
  },
  container: {
    ...container,
    paddingLeft: 0,
    paddingRight: 0,
  },
  map: {
    marginTop: "70px",
  },
});

export default appStyle;
